<template>
  <div class="body-width" >
    <div class="div-row div-pad-top news-Medium-24" >
      海上应急演练系统
    </div>
    <div class="div-row">
      <p class="indentation">V.Dragon-EmergDrill5000型海上应急演练系统根据国际SOLAS公约、STCW公约、OPRC公约和国家重大海上溢油应急处置预案及DNV-GL相关标准等对船员、应急操作人员培训评估的有关要求研制而成。系统可用于应急现场的船舶和直升机驾驶员等的海上应急操作训练，海上应急指挥中心、应急现场指挥人员的应急资源调度管理、应急协调指挥训练，海上应急处置预案的可行性论证演练、海事案例重现分析，具有经济性、实效性和安全性。</p>
    </div>
    <div class="img_pad">
      <img src="../../../../assets/images/productcenter/hsyl/hsyj/1.png">
    </div>
    <div class="pad_top_30">
    <div>
      <div align="left">
        <b>溢油应急演练</b>
      </div>
      <div align="left" class="div_float_left">
        <ul>
          <li><span>基于多相流模型的溢油扩散漂流动态演化</span></li>
          <li><span>海上浮油与应急设备交互</span></li>
          <li><span>围油栏、收油机、吸油毡、消油剂等清污操作</span></li>
          <li><span>应急资源动态管理</span></li>
          <li><span>资源敏感区域设置</span></li>
          <li><span>溢油事故应急调度指挥</span></li>
        </ul>
      </div>
      <div class="div_float_right pad_right">
        <img src="../../../../assets/images/productcenter/hsyl/hsyj/2.png">
      </div>
    </div>
    <div style="padding-top: 296px">
        <div align="left">
          <b>船舶消防演练</b>
        </div>
        <div align="left" class="div_float_left">
          <ul>
            <li><span>基于元胞自动机的船舶火灾蔓延</span></li>
            <li><span>灭火规程动态演示</span></li>
            <li><span>典型消防设备的操作训练</span></li>
            <li><span>消防战术演练</span></li>
            <li><span>逃生路径规划及逃生过程演练</span></li>
          </ul>
        </div>
        <div class="div_float_right pad_right">
          <img src="../../../../assets/images/productcenter/hsyl/hsyj/3.png">
        </div>
      </div>
    <div style="padding-top: 296px">
        <div align="left">
          <b>海上事故重演</b>
        </div>
        <div align="left" class="div_float_left">
          <ul>
            <li><span>VDR数据多维呈现</span></li>
            <li><span>海事案例数据回放</span></li>
            <li><span>海难事故致因分析</span></li>
          </ul>
        </div>
        <div class="div_float_right pad_right">
          <img src="../../../../assets/images/productcenter/hsyl/hsyj/4.png">
        </div>
      </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: "hsyjylxt"
  }
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .img_pad{

  }
  .pad_top_30{
    padding-top: 30px;
  }
  .div_float_left{
    float: left;
  }
  .div_float_right{
    float: right;
  }
  .pad_right{
   padding-right: 35px;
  }
  li{
    color: #2E79BE;

  }
  li span{
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hsylxlcp/hsyjylxt.vue